// @flow strict
import React from 'react';
import styled from '@emotion/styled';

type Props = {
  height: String,
};

const Solid = ({ height }: Props) => <RuledLine height={height} />;

const RuledLine = styled.hr((props) => ({
  backgroundColor: props.theme.colors.primary,
  height: props.height,
  marginBottom: 0,
}));

export default Solid;
